import React, { useEffect, useState } from "react";
import { Section, SectionTitle, Reveal } from "../components/Section";

const Box = ({ value, label }) => (
  <div className="flex flex-col items-center bg-ivory/60 backdrop-blur-sm border border-gold/30 px-4 py-5 md:px-6 md:py-7 min-w-[72px] md:min-w-[96px]">
    <span className="font-serif text-4xl md:text-5xl text-charcoal tabular-nums">{String(value).padStart(2, "0")}</span>
    <span className="text-[10px] md:text-xs tracking-[0.25em] uppercase text-gold mt-2">{label}</span>
  </div>
);

export default function Countdown({ target }) {
  const calc = () => {
    const diff = Math.max(0, target.getTime() - Date.now());
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    return { days, hours, minutes, seconds };
  };

  const [t, setT] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line
  }, [target]);

  return (
    <Section testId="countdown-section" className="bg-cream/40">
      <SectionTitle overline="Save The Date" title="Counting" italic="the moments" />
      <Reveal>
        <div className="flex justify-center gap-3 md:gap-5" data-testid="countdown-display">
          <Box value={t.days} label="Hari" />
          <Box value={t.hours} label="Jam" />
          <Box value={t.minutes} label="Menit" />
          <Box value={t.seconds} label="Detik" />
        </div>
      </Reveal>
      <Reveal delay={0.3}>
        <p className="text-center mt-10 font-serif italic text-charcoal/70 text-lg">
          Menanti hari yang dinanti, dengan sukacita dan doa.
        </p>
      </Reveal>
    </Section>
  );
}
